import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import { useSnackbarContext } from 'Context/SnackbarContext';
import {
  useIdentityVerificationReviewsContext,
} from 'Components/AdvisorApp/Viewport/ApexAdminPortal/IdentityVerificationReviews/IdentityVerificationReviewsContext';
import ReadOnlyField from 'Components/UI/Overrides/ReadOnlyField';
import Button from 'Components/UI/Button';

const styles = (theme) => ({
  root: {
    paddingBottom: 0,
  },
  button: {
    borderRadius: theme.radius.md,
  },
});

const AssignToMeButton = ({
  className,
  classes,
  resource,
}) => {
  const { displayErrorMessage } = useSnackbarContext();
  const { refreshIdentityVerificationReviewsCollection } = useIdentityVerificationReviewsContext();

  const onAssignedToMe = async (e) => {
    try {
      e.preventDefault();
      e.stopPropagation();
      await resource.relationship(fr.relationships.assignToMe.name).link('related').put({}, { deprecatedAllowAlterOfRelation: true });
      refreshIdentityVerificationReviewsCollection();
    } catch (err) {
      displayErrorMessage('failed to assign to review');
    }
  };

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {resource.attr('assignedTo') && (
        <ReadOnlyField classes={classes} value={resource.selectedOptionPrompt('assignedTo')} />
      )}
      {!resource.attr('assignedTo') && (
        <Button
          className={classes.button}
          variant="contained"
          color="primary"
          disableElevation
          onClick={(e) => onAssignedToMe(e)}
        >
          {'Assign To Me'}
        </Button>
      )}
    </Box>
  );
};

AssignToMeButton.defaultProps = {
  className: '',
};

AssignToMeButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
};

export default withStyles(styles)(AssignToMeButton);
